import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/voip-disposition'),
      name: 'voip_disposition_settings',
      redirect: to => ({
        name: 'voip_calls_settings',
        params: { accountId: to.params.accountId },
        query: { tab: 'finalizacao' },
      }),
      meta: { permissions: ['administrator'] },
    },
  ],
};
